import * as React from "react";
import {Container, Flag, Grid, Image} from "semantic-ui-react";
import i18n from "../../../../locale/i18n";
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";
const t = i18n.t.bind(i18n);
const logo = require('../../logo.svg');

interface RegistrationContainerProps {

}

interface RegistrationContainerSate {

}

class RegistrationContainer extends React.Component<RegistrationContainerProps ,RegistrationContainerSate> {

    constructor(props: RegistrationContainerProps) {
        super(props);

        this.onChangeLanguage = this.onChangeLanguage.bind(this);
    }

    onChangeLanguage(language : string) {
        i18n.changeLanguage(language);
        this.forceUpdate();
    }

    componentDidMount(): void {
    }

    render(): React.ReactNode {
        return (
            <Grid centered={true} verticalAlign="middle" className={"login-grid"}>
                <AnalyticsTracking page="registration_notice" />
                <Grid.Row divided={true}>
                    <Grid.Column widescreen="4" mobile="15" tablet="7" computer="5" largeScreen="4">
                        <Image src={logo} alt="Landgard Logo" spaced={false} size="medium" centered={true}/>
                        <h2 className={"loginHeading"}> {t("Login.Heading")}</h2>

                        <Grid centered={true} verticalAlign="middle" className={"login-grid"}>
                            <Grid.Column>
                                <Flag name={"de"} className={"languageChangeFlag"} onClick={()=> {this.onChangeLanguage("de")}}/>
                            </Grid.Column>
                            <Grid.Column>
                                <Flag name={"gb"} className={"languageChangeFlag"} onClick={()=> {this.onChangeLanguage("en")}}/>
                            </Grid.Column>
                            <Grid.Column>
                                <Flag name={"nl"} className={"languageChangeFlag"} onClick={()=> {this.onChangeLanguage("nl")}}/>
                            </Grid.Column>
                        </Grid>

                        <Container textAlign='left'>
                            {t("Login.Text1")}
                            <br/>
                            <br/>
                            {t("Login.Text2")}
                            <ul>
                                <li>{t("Login.ListItem1")} +49 2832 921-3110</li>
                                <li>{t("Login.ListItem2")} stammdaten@landgard.de</li>
                            </ul>

                            {t("Login.Text3")}

                        </Container>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }

}

export default RegistrationContainer;